'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    TBody: ()=>TBody
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const external_TBody_variants_cjs_namespaceObject = require("./TBody.variants.cjs");
const external_TBody_context_cjs_namespaceObject = require("./TBody.context.cjs");
const external_cleanTableProps_cjs_namespaceObject = require("../cleanTableProps.cjs");
const index_cjs_namespaceObject = require("../Table/index.cjs");
const Span_cjs_namespaceObject = require("../../Text/Span.cjs");
const external_utils_index_cjs_namespaceObject = require("../../../utils/index.cjs");
function TBody({ children, className, ...props }) {
    const { maxColumns: tableMaxColumns } = (0, index_cjs_namespaceObject.useTableContext)();
    const { maxColumns: tableBodyMaxColumns } = props;
    const maxColumns = tableBodyMaxColumns ?? tableMaxColumns;
    const classes = (0, external_utils_index_cjs_namespaceObject.cn)((0, external_TBody_variants_cjs_namespaceObject.tBodyVariants)(props), className);
    const hasChildren = external_react_namespaceObject.Children.toArray(children).some((child)=>null !== child);
    const cleanedProps = (0, external_cleanTableProps_cjs_namespaceObject.cleanTableProps)(props);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_TBody_context_cjs_namespaceObject.TableBodyContext.Provider, {
        value: props,
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("tbody", {
            className: classes,
            ...cleanedProps,
            children: [
                children,
                !hasChildren && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("tr", {
                    className: "h-35",
                    children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("td", {
                        className: "size-full place-content-center justify-center",
                        colSpan: maxColumns,
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                            className: "text-neutral-10 text-body2 flex justify-center",
                            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Span_cjs_namespaceObject.Span, {
                                children: "No Data Available"
                            })
                        })
                    })
                })
            ]
        })
    });
}
exports.TBody = __webpack_exports__.TBody;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "TBody"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
